<template>
  <div
    class="no-shrink"
    :class="{ active: active }"
  >
    <div :class="spanClass">
      <QToggle
        v-model="handleVerifiedEnabled"
        class="full-width justify-between"
        :color="toggleColor"
        dense
        :disable="disabled"
        :label="$t('social_impact_expandable.verified')"
        left-label
      />
    </div>

    <div :class="spanClass">
      <QToggle
        v-model="handleMinimumFollowerCountEnabled"
        class="full-width justify-between"
        :color="toggleColor"
        dense
        :disable="disabled"
        :label="$t('social_impact_expandable.minimum_followers')"
        left-label
      />
    </div>
    <BaseInputSelect
      v-if="minimumFollowerCountEnabled"
      v-model="handleMinimumFollowerCount"
      class="q-mt-sm"
      :disabled="disabled"
      emit-value
      new-design
      option-label="label"
      option-prop="value"
      :options="minimumFollowerOptions"
    />

    <slot name="after" />
  </div>
</template>

<script>
import { BaseInputSelect } from "shared/components/base";

const MINIMUM_FOLLOWER_OPTIONS = [500, 1000, 5000, 10000, 25000, 50000, 100000];

export default {
  name: "SocialImpactExpandable",
  components: {
    BaseInputSelect,
  },
  props: {
    active: {
      type: Boolean,
    },
    minimumFollowerCount: {
      type: Number,
      default: 500,
    },
    minimumFollowerCountEnabled: {
      type: Boolean,
    },
    verifiedEnabled: {
      type: Boolean,
    },
    toggleColor: {
      type: String,
      default: "",
    },
    spanClass: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
    },
  },
  emits: [
    "update:minimumFollowerCountEnabled",
    "update:minimumFollowerCount",
    "search",
    "update:verifiedEnabled",
  ],
  computed: {
    minimumFollowerOptions() {
      return MINIMUM_FOLLOWER_OPTIONS.map((option) => ({
        label: option.toLocaleString(),
        value: option,
      }));
    },
    handleMinimumFollowerCountEnabled: {
      get() {
        return this.minimumFollowerCountEnabled;
      },
      set(value) {
        this.$emit("update:minimumFollowerCountEnabled", value);

        if (value) this.trackMinimumFollowerCount(this.minimumFollowerCount);
      },
    },
    handleMinimumFollowerCount: {
      get() {
        return this.minimumFollowerCount;
      },
      set(value) {
        this.$emit("update:minimumFollowerCount", value);
        this.$emit("search");

        this.trackMinimumFollowerCount(value);
      },
    },
    handleVerifiedEnabled: {
      get() {
        return this.verifiedEnabled;
      },
      set(value) {
        if (value) this.$track("Filtered Social Stream by Verified Account");

        this.$emit("update:verifiedEnabled", value);
      },
    },
  },
  methods: {
    trackMinimumFollowerCount(value) {
      this.$track("Filtered Social Stream by Minimum Follower Count", {
        option: value,
      });
    },
  },
};
</script>
